var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-facet-values",
      class: {
        "rb-facet-values--list": _vm.facet.layout === "list",
      },
    },
    [
      _vm._l(_vm.facet.values, function (value, index) {
        return [
          value.showFacet
            ? _c(
                _vm.getFacetComponent(_vm.facet.type),
                _vm._b(
                  {
                    key: index,
                    tag: "component",
                    attrs: {
                      "data-mnt-name": _vm.dataMntName,
                      "min-price-range": _vm.minPriceRange,
                      "max-price-range": _vm.maxPriceRange,
                      "is-in-panel": true,
                      "reset-facet-price": _vm.resetFacetPrice,
                      "applied-facets": _vm.appliedFacets,
                    },
                  },
                  "component",
                  Object.assign({}, value),
                  false
                )
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }